import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoginForm from './pages/LoginForm/Main/Login/index';
import AppRoutes from './routes';
import OpenRoutes from './routesOpen';
import PruffConnectRoutes from './routesPruffConnect';
import PruffConnectOpenRoutes from './routesPruffConnectOpen';
import { logout } from './services/redux/authSlice';
import { RootState } from './services/redux/store';

export const DATA_VERSION = '1.1';
export const APP_DOMAINS = ['app', 'localhost', 'dev'];

const App: React.FC = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const domain = window.location.hostname;
  const subdomain = domain.split('.')[0];
  let isPruffConnect = false;
  if (!APP_DOMAINS.includes(subdomain)) isPruffConnect = true;

  if (auth.isAuthenticated) {
    // List of properties that the User type should have
    const userProperties = [
      'email',
      'name',
      'companyName',
      'permissionPolicy',
      'id',
      'roles',
      'companyTypes',
      'companyId',
    ];
    // Check if auth.user has all properties
    const hasAllProperties = userProperties.every(
      (prop) =>
        auth.user && Object.prototype.hasOwnProperty.call(auth.user, prop),
    );
    if (auth.user?.dataVersion !== DATA_VERSION) {
      dispatch(logout());
      return <LoginForm />;
    }
    if (!hasAllProperties) {
      dispatch(logout());
      return <LoginForm />;
    }

    if (isPruffConnect) {
      return <PruffConnectRoutes />;
    }
    return <AppRoutes />;
  } else {
    if (isPruffConnect) {
      return <PruffConnectOpenRoutes />;
    }
    return <OpenRoutes />;
  }
};

export default App;
